import { useState, type FormEvent } from "react"
import { Link } from "react-router-dom"
import { Mail, ArrowLeft } from "lucide-react"
import { forgotPassword } from "../../api/auth"
import AuthCard, { AuthFormError } from "./AuthCard"

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      await forgotPassword(email)
      setSent(true)
    } catch {
      setError("Ocurrió un error. Intenta de nuevo.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthCard title="Science Fitness" subtitle="Restablecer Contraseña">
      {sent ? (
        <div className="text-center space-y-4">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 border border-primary/30">
            <Mail size={28} className="text-primary" />
          </div>
          <p className="text-sm text-muted">
            Si el email <span className="text-white font-medium">{email}</span> está registrado,
            recibirás un enlace para restablecer tu contraseña.
          </p>
          <p className="text-xs text-muted/70">Revisa tu bandeja de entrada y spam.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <p className="text-sm text-muted text-center">
            Ingresa tu email y te enviaremos instrucciones para restablecer tu contraseña.
          </p>

          <div>
            <label className="mb-1.5 block text-xs font-medium text-muted uppercase tracking-wide">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              required
              className="w-full rounded-lg border border-white/10 bg-surface-elevated px-4 py-3 text-white placeholder-muted/50 focus:border-primary"
            />
          </div>

          <AuthFormError error={error} />

          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 rounded-lg bg-primary py-3 font-semibold text-black transition hover:opacity-90 glow-cyan disabled:opacity-50"
          >
            <Mail size={16} />
            {loading ? "Enviando..." : "Enviar Instrucciones"}
          </button>
        </form>
      )}

      <p className="mt-6 text-center text-sm text-muted">
        <Link
          to="/login"
          className="inline-flex items-center gap-1 text-primary hover:text-primary/80 transition"
        >
          <ArrowLeft size={14} />
          Volver al inicio de sesión
        </Link>
      </p>
    </AuthCard>
  )
}
